var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPdfDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "pdf-download"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14.3796 15.5834L14.3796 15.5834C14.5412 15.7447 14.7562 15.8336 14.9845 15.8336C15.2128 15.8336 15.4282 15.7447 15.5892 15.5833L19.0896 12.083C19.3349 11.8376 19.4079 11.4718 19.2754 11.1514C19.143 10.8302 18.8327 10.6226 18.4849 10.6226H17.6768V7.81592C17.6768 7.34378 17.2932 6.96016 16.821 6.96016H13.1477C12.6759 6.96016 12.2923 7.34415 12.2923 7.81592V10.6226H11.4841C11.137 10.6226 10.8268 10.8299 10.6937 11.1506L10.6936 11.1507C10.5609 11.4714 10.6334 11.8376 10.8792 12.083L14.3796 15.5834ZM14.9845 14.579L12.1657 11.7602H12.8612C13.1756 11.7602 13.4302 11.5056 13.4302 11.1912V8.09772H16.5389V11.1912C16.5389 11.5057 16.7938 11.7602 17.1078 11.7602H17.803L14.9845 14.579Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M25.7304 5.80125L20.4788 0.549684C20.4788 0.549674 20.4788 0.549663 20.4788 0.549653C20.1821 0.252698 19.7867 0.0890625 19.367 0.0890625H5.3492C4.48191 0.0890625 3.77656 0.794407 3.77656 1.6617V28.3031C3.77656 29.1704 4.48191 29.8758 5.3492 29.8758H24.6183C25.4856 29.8758 26.1913 29.1705 26.1913 28.3031V6.91333C26.1913 6.49333 26.0273 6.09785 25.7304 5.80125ZM20.3516 2.03148L24.2483 5.92848H20.6971C20.5067 5.92848 20.3519 5.77345 20.3519 5.58297L20.3516 2.03148ZM5.3492 1.22695H19.214V5.58297C19.214 6.40085 19.8791 7.06637 20.6971 7.06637H25.0534V17.849H4.91445V1.6617C4.91445 1.42191 5.10941 1.22695 5.3492 1.22695ZM24.6183 28.7379H5.3492C5.10941 28.7379 4.91445 28.5429 4.91445 28.3031V18.9872H25.0534V28.3035C25.0534 28.5428 24.8582 28.7379 24.6183 28.7379Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M10.4122 20.7297H8.45488C8.14044 20.7297 7.88594 20.9846 7.88594 21.2986V24.5435V26.7656C7.88594 27.0797 8.14044 27.3346 8.45488 27.3346C8.76932 27.3346 9.02383 27.0797 9.02383 26.7656V25.1125H10.4122C11.2413 25.1125 11.9157 24.4381 11.9157 23.609V22.2335C11.9157 21.4041 11.2413 20.7297 10.4122 20.7297ZM10.7778 23.6086C10.7778 23.81 10.6138 23.9742 10.4122 23.9742H9.02383V21.8672H10.4122C10.6138 21.8672 10.7778 22.0315 10.7778 22.2332V23.6086Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M13.4881 27.3342H15.3493C16.2314 27.3342 16.9489 26.6167 16.9489 25.7346V22.3293C16.9489 21.4472 16.2314 20.7297 15.3493 20.7297H13.4881C13.1736 20.7297 12.9191 20.9846 12.9191 21.2986V26.7653C12.9191 27.0793 13.1736 27.3342 13.4881 27.3342ZM15.3493 26.1963H14.057V21.8676H15.3493C15.6039 21.8676 15.811 22.075 15.811 22.3293V25.7346C15.811 25.9892 15.6036 26.1963 15.3493 26.1963Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M21.5128 20.7297H18.6209C18.3068 20.7297 18.052 20.9846 18.052 21.2986V26.7653C18.052 27.0794 18.3068 27.3342 18.6209 27.3342C18.935 27.3342 19.1898 27.0794 19.1898 26.7653V24.6007H20.5147C20.8288 24.6007 21.0836 24.3459 21.0836 24.0318C21.0836 23.7177 20.8288 23.4628 20.5147 23.4628H19.1898V21.8672H21.5128C21.8269 21.8672 22.0817 21.6124 22.0817 21.2983C22.0817 20.9842 21.8268 20.7297 21.5128 20.7297Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.15
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdfDownload);
export default __webpack_public_path__ + "static/media/pdf-download.64c3ce68ca54ec5c192e059c3e482f31.svg";
export { ForwardRef as ReactComponent };